
import { Link } from 'react-router-dom';
import AnimatedSeparator from '../components/AnimatedSeparator';

export default function AboutPage() {

    return (
        <div className="page-container">
            <div className="container">
                <div className="row page-hero align-items-end">
                    <div className="col-md-7">
                        <h1>The Nursery Team</h1>
                        <h2>impatient goblins on a mission to build the Martriarchy.</h2>
                    </div>
                </div>

                <AnimatedSeparator color="#000" />

                <div className="row">
                    <div className="col-md-3">
                        <h3 style={{ color: '#f52e72' }}>Ela Shapira</h3>
                    </div>
                    <div className="col-md-8 offset-md-1">
                        <h3>Startup Doula; Foundress & CEO</h3>
                        <p>20+ years in early-stage startups · Serial foundress with 2 patents authored · Author of <em>Secrets of a Startup Doula</em></p>
                        <div className="book-actions btn-row">
                            <Link to="/about-ela" className="btn-secondary">learn more</Link>
                        </div>
                    </div>
                </div>

                <AnimatedSeparator color="#f52e72" />

                <div className="row">
                    <div className="col-md-8">
                        <h3>Branding & Design; CMO</h3>
                        <p>15+ years in graphic design · Known for creating unique visual identities · Co-Foundress of <Link to="https://www.cominghomesoon.online/" target="_blank" rel="noreferrer">Coming Home Soon</Link></p>
                        <div className="book-actions btn-row">
                            <Link to="https://www.katyamo.com/" className="btn-secondary" target="_blank" rel="noreferrer">
                                learn more
                            </Link>
                        </div>
                    </div>
                    <div className="col-md-3 offset-md-1">
                        <img src="/images/katyamo-logo.avif" alt="Katya Mo Graphic Design" className="img-fluid" />
                    </div>
                </div>

                <AnimatedSeparator color="#000" />

                <div className="row">
                    <div className="col-md-3">
                        <h3 style={{ color: '#f52e72' }}>Shani Weitzner-Angluster</h3>
                    </div>
                    <div className="col-md-8 offset-md-1">
                        <h3>Test-Driven Development; CTO</h3>
                        <p>15+ years in corporate tech · Expert in making tech do what it should · Entrepreneuress</p>
                        <div className="book-actions btn-row">
                            <Link to="https://nl.linkedin.com/in/shani-weitzner-angluster" className="btn-secondary" target="_blank" rel="noreferrer">
                                learn more
                            </Link>
                        </div>
                    </div>
                </div>

                <AnimatedSeparator color="#f52e72" />

                <div className="row">
                    <div className="col-md-8">
                        <h3>Customer Experience Architect; CXO</h3>
                        <p>25+ years in business transformation · 470+ projects across industries and timezones · Foundress of <Link to="https://www.emprendeplan.com/" target="_blank" rel="noreferrer">EmprendePlan</Link></p>
                        <div className="book-actions btn-row">
                            <Link to="https://ibaezgil.com/" className="btn-secondary" target="_blank" rel="noreferrer">
                                learn more
                            </Link>
                        </div>
                    </div>
                    <div className="col-md-3 offset-md-1" style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center' }}>
                        <img src="/images/isabel-baez-logo.avif" alt="Isabel Baez Business Transformation Consultant" className="img-fluid"
                            style={{ maxHeight: '200px' }} />
                    </div>
                </div>

                <AnimatedSeparator color="#000" />

                <div className="row">
                    <div className="col-md-3">
                        <h3 style={{ color: '#f52e72' }}>Hana Kim</h3>
                    </div>
                    <div className="col-md-8 offset-md-1">
                        <h3>Legal & Marketing Advisoress</h3>
                        <p>20+ years experience in marketing and US law · Complementing marketing strategy with legal background · Entrepreneuress</p>
                        <div className="book-actions btn-row">
                            <Link to="https://nl.linkedin.com/in/hanakim" className="btn-secondary" target="_blank" rel="noreferrer">
                                learn more
                            </Link>
                        </div>
                    </div>
                </div>

                <AnimatedSeparator color="#f52e72" />

                <div className="row">
                    <div className="col-md-6">
                        <h5>Want to join the team as an advisoress?</h5>
                        <p style={{ paddingBottom: '1.5rem' }}>
                            Send us an email to&nbsp;
                            <Link sx={{ cursor: "pointer" }}
                                onClick={() => window.location.href = `mailto:${'nursery'}@${'startup-doula.com'}`}>
                                {'nursery'}&#64;{'startup-doula.com'}
                            </Link>

                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
